import React from 'react';
import { useParams } from 'react-router-dom';
import { Spinner } from '@guryou/html-components';
import { stateIsLoading, useUserVideoCourse } from '@guryou/redux';
import UserVideoCourseFiles from './UserVideoCourseFiles';

const MyVideoCourseFiles = () => {
  const { id } = useParams();
  const userVideoCourse = useUserVideoCourse(id);

  if (stateIsLoading(userVideoCourse)) {
    return <Spinner />;
  }
  return <UserVideoCourseFiles id={id} videoCourse={userVideoCourse.data} />;
};

export default MyVideoCourseFiles;
